import React, { useMemo } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './GooglePagination.css';

const buildPages = (current, total) => {
  if (total <= 1) return [1];
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

  const pages = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);

  if (start > 2) pages.push('...');
  for (let p = start; p <= end; p += 1) pages.push(p);
  if (end < total - 1) pages.push('...');

  pages.push(total);
  return pages;
};

const GooglePagination = ({
  currentPage,
  totalPages,
  onPageChange,
  prevLabel = 'السابق',
  nextLabel = 'التالي',
  infoPrefix = 'صفحة',
  infoMiddle = 'من',
  isRTL = true,
  className = ''
}) => {
  const current = Number(currentPage) || 1;
  const total = Number(totalPages) || 1;

  const pages = useMemo(() => buildPages(current, total), [current, total]);

  if (total <= 1) return null;

  return (
    <div className={`google-pagination ${className}`.trim()}>
      <button
        className="google-pagination-btn"
        disabled={current <= 1}
        onClick={() => onPageChange(current - 1)}
      >
        {isRTL ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
        <span>{prevLabel}</span>
      </button>

      <div className="google-pagination-pages">
        {pages.map((page, idx) => (
          page === '...'
            ? <span key={`ellipsis-${idx}`} className="google-pagination-ellipsis">...</span>
            : (
              <button
                key={`page-${page}`}
                className={`google-pagination-page-btn ${current === page ? 'active' : ''}`}
                onClick={() => onPageChange(page)}
              >
                {page}
              </button>
            )
        ))}
      </div>

      <span className="google-pagination-info">
        {infoPrefix} {current} {infoMiddle} {total}
      </span>

      <button
        className="google-pagination-btn"
        disabled={current >= total}
        onClick={() => onPageChange(current + 1)}
      >
        <span>{nextLabel}</span>
        {isRTL ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
      </button>
    </div>
  );
};

export default GooglePagination;
